import React from 'react';

import { gql } from '@apollo/client';
import { useTranslation } from '@modernloop/i18n';

import { ActivityLogTaskTagRemoved_ActivityLogFragment } from 'src/generated/mloop-graphql';

import { FCWithFragments } from 'src/components/types';

import ActivityLogBase from '../../Helpers/ActivityLogBase';

interface Fragments {
  activityLog: ActivityLogTaskTagRemoved_ActivityLogFragment;
}

const ActivityLogTaskTagRemoved: FCWithFragments<Fragments> = ({ activityLog }) => {
  const { t } = useTranslation();
  const { details } = activityLog;

  // eslint-disable-next-line no-underscore-dangle
  if (!details || details.__typename !== 'ActivityLogTaskTagDetails') {
    throw new Error('ActivityLogTaskTagRemoved: details is not ActivityLogTaskTagDetails');
  }

  const tagsList = details.taskTags;
  const tagsString = tagsList.map((taskTag) => taskTag.name).join(', ');
  return (
    <ActivityLogBase
      activityLog={activityLog}
      actionLabel={t('hiring-dashboard-common:common.activityLog.removedTags', {
        count: tagsList.length,
        tags: tagsString,
      })}
    />
  );
};

ActivityLogTaskTagRemoved.fragments = {
  activityLog: gql`
    ${ActivityLogBase.fragments.activityLog}
    fragment ActivityLogTaskTagRemoved_activityLog on ActivityLog {
      id
      details {
        ... on ActivityLogTaskTagDetails {
          taskTags {
            id
            name
          }
        }
      }
      ...ActivityLogBase_activityLog
    }
  `,
};

export default ActivityLogTaskTagRemoved;
